module.exports = __webpack_public_path__ + "assets/img/img43.3abf3c15.png";